export const env = {
    apiBaseUrl: 'https://cab-gateway.signitydemo.in/api/',
    imageUrl: 'https://d16xdy485vjfhf.cloudfront.net/',
   
  }